import React from 'react';
import { useNavigate } from "react-router-dom";
import SkeletonBox from '../SkeletonBox';
import CardTitle from '../CardTitle';
import { Card, Icon, Progress, Empty } from 'antd';
import { getProgressColorByScore, getStatusByScore } from '../../deepAnalysis/utils';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';
import "./PageGroupInsights.less";


type Props = {
    websiteGuid: string;
    isLoading: boolean;
    isRunningDeepAnalysis: boolean;
    pageGroups: {
        guid: string;
        title: string;
        description: string;
        seo_score: number;
        top_issues: {
            title: string;
            seo_test_key: string;
        }[];
    }[];
};

export default function PageGroupInsightsBox({ isLoading, websiteGuid, pageGroups, isRunningDeepAnalysis }: Props) {
    const navigate = useNavigate();

    return (
        <div className="dashboard-page-groups-box">
            {isLoading && <SkeletonBox />}

            {!isLoading && (
                <Card
                    title={
                        <CardTitle
                            title="Page Group Insights"
                            description="Overview of your key page groups and their top SEO issues"
                        />
                    }
                >
                    {isRunningDeepAnalysis ? (
                        <LoadingIndicator
                            detailed
                            text="SEO audit in progress..."
                            subTitle="We are currently analyzing your monitored URLs for SEO issues."
                        />
                    ) : (
                        <>
                            {pageGroups.length === 0 && (
                                <Empty className="empty-state" image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data" />
                            )}

                            {pageGroups.length > 0 && (
                                <div className="top-page-groups">
                                    {pageGroups.map((pageGroup, index) => (
                                        <div key={index} className="page-group-overview">
                                            <div className={`detail ${getStatusByScore(pageGroup.seo_score)}`}>
                                                <div className="title">{pageGroup.title}</div>
                                                <div className="description">{pageGroup.description}</div>
                                            </div>
                                            <div className="content">
                                                <div className="seo-score-container">
                                                    <h4>SEO Score</h4>
                                                    <div className="seo-score">
                                                        <Progress
                                                            type="circle"
                                                            percent={pageGroup.seo_score}
                                                            strokeWidth={6}
                                                            strokeColor={getProgressColorByScore(pageGroup.seo_score)}
                                                            format={(percent) => `${percent}/100`}
                                                        />
                                                    </div>
                                                </div>
                                                {pageGroup.top_issues.length > 0 ? (
                                                    <div className="top-issues">
                                                        <h4>Top issues</h4>
                                                        <ul>
                                                            {pageGroup.top_issues.map((issue, index) => (
                                                                <li key={index} className="item">
                                                                    <Icon type="close-circle" />
                                                                    <span className="link" onClick={() => navigate(`/deep-analysis/failed-check/${issue.seo_test_key}?w_guid=${websiteGuid}&cluster_guid=${pageGroup.guid}`)}>{issue.title}</span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </Card>
            )}
        </div>
    );
}
